import React, { useState } from "react";
import donationOptions from "../utility/donationDetail.js";
import "../css/accordion.css";
import { Link } from "react-router-dom";

const DonationAccordion = () => {
  // Initialize selectedCategory with the first category from donationOptions
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(donationOptions)[0]
  );

  const handleSelection = (category) => {
    setSelectedCategory(category === selectedCategory ? null : category);
  };

  return (
    <div className="donation-wrapper">
      <h2 className="donation-header">दान श्रेणी</h2>
      <div className="accordion">
        {Object.keys(donationOptions).map((category, index) => (
          <div className="accordion-item" key={index}>
            <div
              className="accordion-title"
              onClick={() => handleSelection(category)}
            >
              <h3>{category.replace(/_/g, " ")}</h3>
              <span>{selectedCategory === category ? "−" : "+"}</span>
            </div>
            {selectedCategory === category && (
              <div className="accordion-content">
                <table className="donation-table">
                  <thead>
                    <tr>
                      <th>देणगी स्वरूप</th>
                      <th>राशि (₹)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(donationOptions[category]).map(
                      ([key, value], idx) => (
                        <tr key={idx}>
                          <td>{key}</td>
                          <td>{value !== null ? value : "स्वेच्छानुसार"}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <div className="donation-button-container">
                  <Link to={`/donate`}>
                    <button className="donation-button"><b>देणगी</b> </button>
                  </Link>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonationAccordion;
